import React from 'react';
import { Check } from 'lucide-react';

// Presentational readout for the password requirements enforced by
// validateRegistrationPassword (src/utils/registrationValidation.js) — this
// component only renders the already-computed `requirements`/`score`, it
// does not decide what counts as strong.
const REQUIREMENTS = [
  { key: 'length', text: 'Au moins 8 caractères' },
  { key: 'upperCase', text: 'Une majuscule (A-Z)' },
  { key: 'lowerCase', text: 'Une minuscule (a-z)' },
  { key: 'numbers', text: 'Un chiffre (0-9)' },
  { key: 'specialChar', text: 'Un caractère spécial (!@#$)' },
];

const LEVELS = [
  { max: 2, label: 'Faible', className: 'auth-strength-weak' },
  { max: 3, label: 'Moyen', className: 'auth-strength-medium' },
  { max: 4, label: 'Bon', className: 'auth-strength-good' },
  { max: 5, label: 'Fort', className: 'auth-strength-strong' },
];

export default function PasswordStrength({ requirements, score }) {
  const level = LEVELS.find((l) => score <= l.max) || LEVELS[LEVELS.length - 1];
  return (
    <div className="auth-strength">
      <div className="auth-strength-row">
        <span className="auth-strength-label">Force du mot de passe</span>
        <span className={`auth-strength-value ${level.className}`}>{level.label}</span>
      </div>
      <div className="auth-strength-track">
        <div className={`auth-strength-fill ${level.className}`} style={{ width: `${(score / 5) * 100}%` }} />
      </div>
      <ul className="auth-strength-requirements">
        {REQUIREMENTS.map((req) => (
          <li key={req.key} className={requirements[req.key] ? 'auth-req-met' : ''}>
            <span className="auth-req-mark" aria-hidden="true">
              {requirements[req.key] ? <Check size={11} /> : null}
            </span>
            {req.text}
          </li>
        ))}
      </ul>
    </div>
  );
}
